/**
 * 把按页面语言选好的 App Store 链接换成大陆网络能打开的写法。
 * 输入：带地区码的商品页链接（如 https://apps.apple.com/us/app/id123）与页面语言。
 * 输出：地区码换成 cn；非中文页面再加 ?l=en 让商品页显示英文。不是 apps.apple.com 的链接原样返回。
 * 为什么：Apple 在大陆的 CDN 会把所有非 /cn/ 的商店链接硬跳到 /cn 首页并丢掉 App 路径，
 * 与 Apple ID 属于哪个区无关；只有 /cn/ 这条在大陆网络下能打开。
 */
export function mainlandAppStoreHref(href: string, locale: string): string {
  if (!href.startsWith("https://apps.apple.com/")) return href;
  const url = new URL(href);
  url.pathname = url.pathname.replace(/^\/[a-z]{2}\//, "/cn/");
  if (!locale.startsWith("zh")) url.searchParams.set("l", "en");
  return url.toString();
}
